import { useTranslations } from "@/contexts/Translation";
import Link from "../Link/Link";
import { Alert, yearStats } from "./insights";
import { categoryLabel } from "./labels";
import styles from "./Index.module.css";

type YearSummaryProps = {
  stats: ReturnType<typeof yearStats>;
  alerts: Alert[];
};

const YearSummary = ({ stats, alerts }: YearSummaryProps) => {
  const t = useTranslations("dashboard");

  const alertText = (alert: Alert) => {
    if (alert.key === "alertStreak") {
      return t(alert.key, t(categoryLabel(String(alert.values[0]))), alert.values[1]);
    }
    return t(alert.key, ...alert.values);
  };

  // The dashboard puts this in a card Section labelled by the heading below.
  return (
    <>
      <h2 id='year-heading' className={styles.panelTitle}>
        {t("yearTitle")}
      </h2>
      <dl className={styles.stats}>
        <div>
          <dt>{t("yearSurveys")}</dt>
          <dd data-testid='year-surveys'>{stats.surveys}</dd>
        </div>
        <div>
          <dt>{t("yearResponses")}</dt>
          <dd data-testid='year-responses'>{stats.responses}</dd>
        </div>
        <div>
          <dt>{t("yearGoals")}</dt>
          <dd data-testid='year-goals'>{stats.goals}</dd>
        </div>
      </dl>
      {alerts.length > 0 && (
        <ul className={styles.alerts}>
          {alerts.map((alert) => (
            <li key={alert.key}>
              <Link href={alert.href}>{alertText(alert)}</Link>
            </li>
          ))}
        </ul>
      )}
    </>
  );
};

export default YearSummary;
